import { render, staticRenderFns } from "./TrendNamesEdit.vue?vue&type=template&id=67ac13ac&"
import script from "./TrendNamesEdit.vue?vue&type=script&lang=js&"
export * from "./TrendNamesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports